import React from 'react';
import classNames from 'classnames';
import $ from '../../../../offline/jquery.min.js';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';

import Utils from '../../../Services/Utils';
import ConfigService from "../../../Services/api/Config";

import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import './style.scss';

class SliderRange extends React.PureComponent {

  constructor(props) {
    super(props);
    this.element = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
    setTimeout(() => {
      if (this.element && this.element.current) {
        $(this.element.current).find('.input-range__track--active').css('background', ConfigService.getColor('secondaryColor'));
        $(this.element.current).find('.input-range__slider').css('background', ConfigService.getColor('secondaryColor'));
        $(this.element.current).find('.input-range__slider').css('border-color', ConfigService.getColor('secondaryColor'));
      }
    });
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) {
      return 'This field is required.';
    }
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (value) => {
    const {onChange, onError, error} = this.props;
    if (onChange) onChange(value);
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      min,
      max,
      step,
      disabled,
      required,
      value,
    } = this.props;

    const WrapperProps = {
      label,
      labelhtml,
      error,
      required,
    };
    let valueField = null;
    if (!Utils.isNull(value)) {
      valueField = value;
    }
    else {
      valueField = (!Utils.isNull(min) ? min : 0);
    }

    return (
      <InputWrapper { ...WrapperProps } className={ classNames(className, 'RateRange', {
            RateRange_Disabled: Boolean(disabled),
          }) }>
        <div className="WrapperRange" ref={ this.element }>
          <InputRange
            maxValue={ max || 100 }
            minValue={ min || 0 }
            value={ valueField }
            disabled={ disabled }
            step={ step }
            onChange={ this.handleChange }
          />
          <input
            defaultValue={ !Utils.isNull(value) ? value : '' }
            disabled={ disabled }
            required={ required }
            hidden={ true }
          />
        </div>
      </InputWrapper>
    );
  }
}

SliderRange.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
};

export default withShallowComparison(SliderRange, ['onChange', 'onError']);
